import { Injectable } from '@angular/core';
import * as _moment from 'moment';
import {FormControl} from '@angular/forms';
import {NgbDate} from '@ng-bootstrap/ng-bootstrap';
@Injectable({
    providedIn: 'root'
})
export class FunctionShared {
    public convertDateToString(date: any) {
        if (date) {
            const dateParse = new Date(date);
            return dateParse.toLocaleDateString('vi-VN');
        } else {
            return '';
        }
    }
    public convertDateServerToString(date: any, strFormat: string) {
        if (date) {
            if (date.toString().indexOf('T') > -1 && date.toString().indexOf('Z') === -1) {
                date = date.toString() + 'Z';
            }
            let dateString;
            if (strFormat) {
                dateString = _moment(date).format(strFormat);
            } else {
                dateString = _moment(date).toDate();
            }
            return dateString;
        } else {
            return '';
        }
    }
    public convertStringToDate(dateString: string, strFormat: string) {
        // var momentObj = _moment(date);
        const dateValue = _moment(dateString, strFormat).toDate();
        return dateValue;
    }
    public convertDateFullToStringIso(date: any) {
        if (date) {
            let dateString;
            dateString = new Date(date).toISOString();
            return dateString;
        }
    }
    public ngbDateToIso(ngbDateData) {
        return this.convertDateFullToStringIso(new Date(Date.UTC(ngbDateData.year, ngbDateData.month - 1, ngbDateData.day)));
    }
    public stringToNgbTime(stringtime) {
        const timeArr = stringtime.split(':')
        // tslint:disable-next-line:radix
        return { hour: parseInt(timeArr[0]), minute: parseInt(timeArr[1]), second: parseInt(timeArr[2]) };
    }
    public stringToNgbDate(stringtime) {
        const now = new Date(stringtime);
        return {year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate()} as NgbDate;
    }
    public strimAll(obj) {
        Object.keys(obj).map(k => obj[k] = typeof obj[k] === 'string' ? obj[k].trim() : obj[k]);
        return obj
    }
    public noWhitespaceValidator(control: FormControl) {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'whitespace': true };
    }
    public fomatNumber(data) {
        if (data) {
            return (data).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace('.00', '');  // 12,345.67
        }
    }
    public validateDateTuDen(hieuluctu, hieulucden) {
        if (hieulucden && hieuluctu) {
            const timeTu = new Date(hieuluctu).getTime();
            const timeDen = new Date(hieulucden).getTime();
            return timeTu > timeDen;
        } else {
            return false;
        }
    }
    public convertNgDateTuDen(data) {
        data['hieuluctu'] = null;
        data['hieulucden'] = null;
        if (data.hasOwnProperty('ngb_hieuluctu') && data['ngb_hieuluctu']) {
            data['hieuluctu'] = this.ngbDateToIso(data['ngb_hieuluctu'])
        }
        if (data.hasOwnProperty('ngb_hieulucden') && data['ngb_hieulucden']) {
            data['hieulucden'] = this.ngbDateToIso(data['ngb_hieulucden'])
        }
        return data;
    }
    public showLoading() {
        const element_load = document.getElementById('page-loading-custom');
        element_load.classList.add('loading');
    }
    public hideLoading() {
        const element_load = document.getElementById('page-loading-custom');
        element_load.classList.remove('loading');
    }
}
